import { useEffect, useState } from "react";
import { Search, Check, X, Copy, QrCode } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Page, Spinner } from "@/components/shared";

export default function Participants() {
  const [parts, setParts] = useState(null);
  const [q, setQ] = useState("");
  const [ctx, setCtx] = useState(null);

  useEffect(() => {
    api.get("/band/participants").then(({ data }) => setParts(data));
    api.get("/band/dashboard").then(({ data }) => setCtx(data.band));
  }, []);

  if (!parts) return <Spinner />;
  const filtered = parts.filter((p) => p.name.toLowerCase().includes(q.toLowerCase()));
  const code = ctx?.code || "ISLAND2026";
  const inviteLink = `${window.location.origin}/join?code=${code}`;

  return (
    <Page>
      <h1 className="font-head font-extrabold text-3xl">Participants</h1>
      <p className="text-sm" style={{ color: "var(--cs-fg2)" }}>{parts.length} masqueraders registered</p>

      <div className="cs-card p-5 mt-5">
        <p className="text-xs font-bold tracking-wide mb-3" style={{ color: "var(--cs-fg2)" }}>ONBOARD MORE PEOPLE</p>
        <div className="grid sm:grid-cols-3 gap-3">
          <div className="rounded-xl p-3" style={{ background: "var(--cs-card-hi)" }}>
            <p className="text-[10px]" style={{ color: "var(--cs-fg2)" }}>BAND CODE</p>
            <div className="flex items-center justify-between mt-1">
              <span className="font-mono font-bold text-lg" style={{ color: "var(--cs-magenta)" }}>{code}</span>
              <button data-testid="participants-copy-code" onClick={() => { navigator.clipboard.writeText(code); toast.success("Code copied"); }} className="cs-tap"><Copy size={16} /></button>
            </div>
          </div>
          <button data-testid="participants-copy-link" onClick={() => { navigator.clipboard.writeText(inviteLink); toast.success("Invite link copied"); }}
            className="cs-tap rounded-xl p-3 text-left" style={{ background: "var(--cs-card-hi)" }}>
            <p className="text-[10px]" style={{ color: "var(--cs-fg2)" }}>INVITE LINK</p>
            <p className="text-sm font-semibold mt-1 flex items-center gap-2"><Copy size={14} /> Copy shareable link</p>
          </button>
          <div className="rounded-xl p-3 flex items-center gap-2" style={{ background: "var(--cs-card-hi)" }} data-testid="participants-qr">
            <QrCode size={40} style={{ color: "var(--cs-magenta)" }} />
            <p className="text-xs" style={{ color: "var(--cs-fg2)" }}>QR for costume pickup</p>
          </div>
        </div>
        <button data-testid="participants-csv-import" onClick={() => toast.success("CSV import ready — connect your participant file (demo)")} className="cs-tap mt-3 text-sm font-semibold" style={{ color: "var(--cs-magenta)" }}>
          + Import participants via CSV
        </button>
      </div>

      <div className="flex items-center gap-2 mt-6 rounded-xl px-3" style={{ background: "var(--cs-card)", border: "1px solid var(--cs-border)", height: 48 }}>
        <Search size={18} style={{ color: "var(--cs-fg2)" }} />
        <input data-testid="participants-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search participants…" className="bg-transparent outline-none flex-1 text-sm" style={{ color: "#fff" }} />
      </div>

      <div className="cs-card mt-4 overflow-hidden">
        {filtered.map((p, i) => (
          <div key={p.id} data-testid={`participant-row-${p.id}`} className="flex items-center justify-between p-4" style={{ borderBottom: i < filtered.length - 1 ? "1px solid var(--cs-border)" : "none" }}>
            <div className="flex items-center gap-3">
              <span className="grid place-items-center rounded-full font-bold text-xs" style={{ width: 36, height: 36, background: "var(--cs-card-hi)", color: "var(--cs-magenta)" }}>
                {p.name.split(" ").map((x) => x[0]).slice(0, 2).join("")}
              </span>
              <div>
                <p className="font-semibold text-sm">{p.name}</p>
                <p className="text-xs" style={{ color: "var(--cs-fg2)" }}>{p.crew || "No crew"}{p.checkin_status ? ` · ${p.checkin_status}` : ""}</p>
              </div>
            </div>
            <span className="flex items-center gap-1.5 text-xs font-semibold" style={{ color: p.passport_completed ? "var(--cs-green)" : "var(--cs-amber)" }}>
              {p.passport_completed ? <><Check size={14} /> Ready</> : <><X size={14} /> Incomplete</>}
            </span>
          </div>
        ))}
      </div>
    </Page>
  );
}
